<!--
RaksaInfo V4 Example Component Template
Demonstrates shared style framework classes with Finnish construction industry context
-->

<div class="app-main-container">

  <!-- Page Header using shared layout classes -->
  <mat-card class="actions-card">
    <mat-card-header class="custom-card-header">
      <mat-card-title class="card-title">
        <mat-icon class="title-icon">warehouse</mat-icon>
        Varastotilaukset - Material Component Examples
      </mat-card-title>
      <mat-card-subtitle class="text-faint">
        Demonstrating RaksaInfo V4 shared styles
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <div class="responsive-actions-btns">
        <button mat-fab extended color="primary" (click)="addNewOrder()">
          <mat-icon>add</mat-icon>
          Uusi tilaus
        </button>
        <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Lisää toiminnot">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="exportToExcel()">
            <mat-icon>file_download</mat-icon>
            <span>Vie Excel</span>
          </button>
          <button mat-menu-item (click)="printReport()">
            <mat-icon>print</mat-icon>
            <span>Tulosta raportti</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="refreshData()">
            <mat-icon>refresh</mat-icon>
            <span>Päivitä tiedot</span>
          </button>
        </mat-menu>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Filters using standard card -->
  <mat-card class="info-card">
    <mat-card-header class="custom-card-header">
      <mat-card-title class="card-title">
        <mat-icon class="title-icon">filter_list</mat-icon>
        Suodattimet
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="app-row">
        <div class="app-col app-col-12 app-col-md-6">
          <mat-form-field class="app-form-field">
            <mat-label>Hae tilauksia</mat-label>
            <input matInput placeholder="Asiakas, kuvaus tai tilausnumero..."
              [formControl]="searchControl"
              (keyup)="onSearchChange($event)">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>

          <div class="app-col app-col-12 app-col-md-3">
            <mat-form-field class="app-form-field">
              <mat-label>Status</mat-label>
              <mat-select [formControl]="statusFilter" multiple>
                <mat-option value="toimitettu">Toimitettu</mat-option>
                <mat-option value="kesken">Kesken</mat-option>
                <mat-option value="odottaa">Odottaa</mat-option>
                <mat-option value="peruttu">Peruttu</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="app-col app-col-12 app-col-md-3">
            <mat-form-field class="app-form-field">
              <mat-label>Prioriteetti</mat-label>
              <mat-select [formControl]="priorityFilter">
                <mat-option value="">Kaikki</mat-option>
                <mat-option value="high">Kiireellinen</mat-option>
                <mat-option value="normal">Normaali</mat-option>
                <mat-option value="low">Matala</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Statistics Cards using shared layout -->
    <div class="app-row">
      <div class="app-col app-col-6 app-col-md-3">
        <mat-card class="info-card status-delivered">
          <mat-card-content>
            <div class="count-badge large">
              <mat-icon class="count-icon">check_circle</mat-icon>
              {{ getOrderCount('toimitettu') }}
            </div>
            <div class="text-center">Toimitettu</div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="app-col app-col-6 app-col-md-3">
        <mat-card class="info-card status-pending">
          <mat-card-content>
            <div class="count-badge large">
              <mat-icon class="count-icon">schedule</mat-icon>
              {{ getOrderCount('kesken') }}
            </div>
            <div class="text-center">Kesken</div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="app-col app-col-6 app-col-md-3">
        <mat-card class="info-card status-waiting">
          <mat-card-content>
            <div class="count-badge large">
              <mat-icon class="count-icon">hourglass_empty</mat-icon>
              {{ getOrderCount('odottaa') }}
            </div>
            <div class="text-center">Odottaa</div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="app-col app-col-6 app-col-md-3">
        <mat-card class="info-card status-cancelled">
          <mat-card-content>
            <div class="count-badge large">
              <mat-icon class="count-icon">cancel</mat-icon>
              {{ getOrderCount('peruttu') }}
            </div>
            <div class="text-center">Peruttu</div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- Data Table using shared table and card classes -->
    <mat-card class="data-card">
      <mat-card-header class="custom-card-header">
        <mat-card-title class="card-title">
          <mat-icon class="title-icon">list</mat-icon>
          Tilausluettelo
        </mat-card-title>
        <div class="responsive-actions-btns">
          <mat-button-toggle-group [formControl]="viewModeControl" aria-label="Näkymä">
            <mat-button-toggle value="table" matTooltip="Taulukko">
              <mat-icon>view_list</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="cards" matTooltip="Kortit">
              <mat-icon>view_module</mat-icon>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </mat-card-header>

      <mat-card-content>
        <!-- Table View using shared responsive table -->
        @if (viewModeControl.value === 'table') {
          <div class="responsive-table-wrapper">
            <mat-table [dataSource]="dataSource" class="responsive-table" matSort>
              <!-- Selection Column -->
              <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                  </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)">
                  </mat-checkbox>
                </mat-cell>
              </ng-container>
              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="header-content">
                    <mat-icon class="header-icon">flag</mat-icon>
                    Status
                  </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let order">
                  <span class="status-indicator" [ngClass]="getStatusClass(order.status)">
                    <mat-icon>{{ getStatusIcon(order.status) }}</mat-icon>
                    {{ getStatusDisplayText(order.status) }}
                  </span>
                </mat-cell>
              </ng-container>
              <!-- Customer Column -->
              <ng-container matColumnDef="customer">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="header-content">
                    <mat-icon class="header-icon">business</mat-icon>
                    Asiakas
                  </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let order">
                  <div class="cell-content">
                    <div class="primary-text">{{ order.customerName }}</div>
                    <div class="secondary-text">{{ order.description }}</div>
                    <div class="text-faint">
                      <mat-icon>place</mat-icon>
                      {{ order.location }}
                    </div>
                  </div>
                </mat-cell>
              </ng-container>
              <!-- Items Column -->
              <ng-container matColumnDef="items">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="header-content">
                    <mat-icon class="header-icon">inventory_2</mat-icon>
                    Tuotteet
                  </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let order">
                  <div class="count-badge">
                    <mat-icon class="count-icon">inventory</mat-icon>
                    {{ order.itemCount }} kpl
                  </div>
                  @if (order.priority === 'high') {
                    <div class="priority-indicator">
                      <mat-icon class="priority-high">priority_high</mat-icon>
                      <span class="text-faint">Kiireellinen</span>
                    </div>
                  }
                </mat-cell>
              </ng-container>
              <!-- Dates Column -->
              <ng-container matColumnDef="dates">
                <mat-header-cell *matHeaderCellDef class="hide-on-mobile">
                  <div class="header-content">
                    <mat-icon class="header-icon">event</mat-icon>
                    Päivämäärät
                  </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let order" class="hide-on-mobile">
                  <div class="cell-content">
                    <div class="secondary-text">
                      <mat-icon>event</mat-icon>
                      Tilattu: {{ order.orderDate | date:'dd.MM.yyyy' }}
                    </div>
                    @if (order.deliveryDate) {
                      <div class="primary-text">
                        <mat-icon>local_shipping</mat-icon>
                        Toimitus: {{ order.deliveryDate | date:'dd.MM.yyyy HH:mm' }}
                      </div>
                    }
                    @if (!order.deliveryDate) {
                      <div class="text-faint">
                        <mat-icon>schedule</mat-icon>
                        Ei toimituspäivää
                      </div>
                    }
                  </div>
                </mat-cell>
              </ng-container>
              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef>
                  <div class="header-content">
                    <mat-icon class="header-icon">more_horiz</mat-icon>
                    Toiminnot
                  </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let order">
                  <div class="action-buttons">
                    <button mat-icon-button color="primary"
                      matTooltip="Näytä tilaus"
                      (click)="viewOrder(order)">
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button mat-icon-button color="accent"
                      matTooltip="Muokkaa"
                      [disabled]="order.status === 'peruttu'"
                      (click)="editOrder(order)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    @if (order.status === 'kesken') {
                      <button mat-icon-button color="primary"
                        matTooltip="Merkitse toimitetuksi"
                        (click)="markAsDelivered(order)">
                        <mat-icon>check_circle</mat-icon>
                      </button>
                    }
                    <button mat-icon-button
                      [matMenuTriggerFor]="actionMenu"
                      matTooltip="Lisää toiminnot">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #actionMenu="matMenu">
                      <button mat-menu-item (click)="duplicateOrder(order)">
                        <mat-icon>content_copy</mat-icon>
                        <span>Monista</span>
                      </button>
                      <button mat-menu-item (click)="printOrder(order)">
                        <mat-icon>print</mat-icon>
                        <span>Tulosta</span>
                      </button>
                      <mat-divider></mat-divider>
                      <button mat-menu-item (click)="deleteOrder(order)"
                        [disabled]="order.status === 'toimitettu'">
                        <mat-icon>delete</mat-icon>
                        <span>Poista</span>
                      </button>
                    </mat-menu>
                  </div>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"
                class="data-row smooth-transition"
                [class.selected-row]="selection.isSelected(row)"
                (click)="selection.toggle(row)">
              </mat-row>
            </mat-table>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons
              [pageSize]="10">
            </mat-paginator>
          </div>
        }

        <!-- Card View using shared grid layout -->
        @if (viewModeControl.value === 'cards') {
          <div class="card-grid">
            @for (order of dataSource.data; track order) {
              <mat-card class="responsive-card"
                [class]="'status-' + order.status">
                <mat-card-header class="custom-card-header">
                  <mat-icon mat-card-avatar>{{ getStatusIcon(order.status) }}</mat-icon>
                  <mat-card-title class="card-title">{{ order.customerName }}</mat-card-title>
                  <mat-card-subtitle>Tilaus #{{ order.id }}</mat-card-subtitle>
                  <div class="responsive-actions-btns">
                    <button mat-icon-button [matMenuTriggerFor]="cardMenu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #cardMenu="matMenu">
                      <button mat-menu-item (click)="viewOrder(order)">
                        <mat-icon>visibility</mat-icon>
                        <span>Näytä</span>
                      </button>
                      <button mat-menu-item (click)="editOrder(order)">
                        <mat-icon>edit</mat-icon>
                        <span>Muokkaa</span>
                      </button>
                    </mat-menu>
                  </div>
                </mat-card-header>
                <mat-card-content>
                  <p class="secondary-text">{{ order.description }}</p>
                  <div class="app-row">
                    <div class="app-col text-faint">
                      <mat-icon>inventory</mat-icon>
                      {{ order.itemCount }} tuotetta
                    </div>
                    <div class="app-col text-faint">
                      <mat-icon>place</mat-icon>
                      {{ order.location }}
                    </div>
                    <div class="app-col text-faint">
                      <mat-icon>event</mat-icon>
                      {{ order.orderDate | date:'dd.MM.yyyy' }}
                    </div>
                  </div>
                  <div class="status-indicator" [ngClass]="getStatusClass(order.status)">
                    {{ getStatusDisplayText(order.status) }}
                  </div>
                  @if (order.priority === 'high') {
                    <div class="priority-indicator">
                      Kiireellinen
                    </div>
                  }
                </mat-card-content>
                <mat-card-actions class="responsive-actions-btns">
                  <button mat-button color="primary" (click)="viewOrder(order)">NÄYTÄ</button>
                  <button mat-button color="accent"
                    [disabled]="order.status === 'peruttu'"
                  (click)="editOrder(order)">MUOKKAA</button>
                </mat-card-actions>
              </mat-card>
            }
          </div>
        }
      </mat-card-content>
    </mat-card>

    <!-- Form Example using shared classes -->
    <mat-card class="info-card">
      <mat-card-header class="custom-card-header">
        <mat-card-title class="card-title">
          <mat-icon class="title-icon">add_box</mat-icon>
          Uusi tilaus - Lomakeesimerkki
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="orderForm" class="app-form-container">

          <!-- Stepper Example -->
          <mat-stepper linear #stepper>

            <!-- Step 1: Basic Info -->
            <mat-step [stepControl]="basicInfoForm">
              <form [formGroup]="basicInfoForm">
                <ng-template matStepLabel>Perustiedot</ng-template>

                <div class="app-row">
                  <div class="app-col app-col-12">
                    <mat-form-field class="app-form-field">
                      <mat-label>Asiakkaan nimi *</mat-label>
                      <input matInput formControlName="customerName"
                        placeholder="Esim. Rakennusliike Virtanen Oy">
                        @if (basicInfoForm.get('customerName')?.hasError('required')) {
                          <mat-error>
                            Asiakkaan nimi on pakollinen
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="app-row">
                    <div class="app-col app-col-12">
                      <mat-form-field class="app-form-field">
                        <mat-label>Kuvaus *</mat-label>
                        <textarea matInput formControlName="description"
                          placeholder="Tilauksen kuvaus..."
                        rows="3"></textarea>
                        @if (basicInfoForm.get('description')?.hasError('required')) {
                          <mat-error>
                            Kuvaus on pakollinen
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="app-row">
                    <div class="app-col app-col-12 app-col-md-6">
                      <mat-form-field class="app-form-field">
                        <mat-label>Prioriteetti</mat-label>
                        <mat-select formControlName="priority">
                          <mat-option value="high">
                            <mat-icon>priority_high</mat-icon>
                            Kiireellinen
                          </mat-option>
                          <mat-option value="normal">
                            <mat-icon>remove</mat-icon>
                            Normaali
                          </mat-option>
                          <mat-option value="low">
                            <mat-icon>keyboard_arrow_down</mat-icon>
                            Matala
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="app-col app-col-12 app-col-md-6">
                      <mat-form-field class="app-form-field">
                        <mat-label>Tuotteiden määrä</mat-label>
                        <input matInput type="number" formControlName="itemCount" min="1">
                        <mat-hint>Syötä positiivinen luku</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="responsive-actions-btns end">
                    <button mat-raised-button color="primary" matStepperNext>Seuraava</button>
                  </div>
                </form>
              </mat-step>

              <!-- Step 2: Location & Dates -->
              <mat-step [stepControl]="locationInfoForm">
                <form [formGroup]="locationInfoForm">
                  <ng-template matStepLabel>Toimitus</ng-template>

                  <div class="app-row">
                    <div class="app-col app-col-12">
                      <mat-form-field class="app-form-field">
                        <mat-label>Toimitusosoite *</mat-label>
                        <input matInput formControlName="location"
                          placeholder="Esim. Helsinki, Punavuori">
                          <mat-icon matSuffix>place</mat-icon>
                          @if (locationInfoForm.get('location')?.hasError('required')) {
                            <mat-error>
                              Toimitusosoite on pakollinen
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="app-row">
                      <div class="app-col app-col-12 app-col-md-6">
                        <mat-form-field class="app-form-field">
                          <mat-label>Toimituspäivä</mat-label>
                          <input matInput [matDatepicker]="picker" formControlName="deliveryDate">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                      </div>

                      <div class="app-col app-col-12 app-col-md-6">
                        <mat-form-field class="app-form-field">
                          <mat-label>Toimitusaika</mat-label>
                          <input matInput type="time" formControlName="deliveryTime">
                          <mat-hint>Valinnainen</mat-hint>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="responsive-actions-btns space-between">
                      <button mat-button matStepperPrevious>Takaisin</button>
                      <button mat-raised-button color="primary" matStepperNext>Seuraava</button>
                    </div>
                  </form>
                </mat-step>

                <!-- Step 3: Review -->
                <mat-step>
                  <ng-template matStepLabel>Tarkistus</ng-template>

                  <div class="responsive-inner-card">
                    <h3>Tarkista tilauksen tiedot</h3>

                    <mat-list>
                      <mat-list-item>
                        <mat-icon matListItemIcon>business</mat-icon>
                        <div matListItemTitle>Asiakas</div>
                        <div matListItemLine>{{ basicInfoForm.get('customerName')?.value }}</div>
                      </mat-list-item>

                      <mat-list-item>
                        <mat-icon matListItemIcon>description</mat-icon>
                        <div matListItemTitle>Kuvaus</div>
                        <div matListItemLine>{{ basicInfoForm.get('description')?.value }}</div>
                      </mat-list-item>

                      <mat-list-item>
                        <mat-icon matListItemIcon>inventory</mat-icon>
                        <div matListItemTitle>Tuotteet</div>
                        <div matListItemLine>{{ basicInfoForm.get('itemCount')?.value }} kpl</div>
                      </mat-list-item>

                      <mat-list-item>
                        <mat-icon matListItemIcon>place</mat-icon>
                        <div matListItemTitle>Toimitusosoite</div>
                        <div matListItemLine>{{ locationInfoForm.get('location')?.value }}</div>
                      </mat-list-item>
                    </mat-list>
                  </div>

                  <div class="responsive-actions-btns space-between">
                    <button mat-button matStepperPrevious>Takaisin</button>
                    <button mat-raised-button color="primary"
                      [disabled]="orderForm.invalid"
                      (click)="saveOrder()">
                      <mat-icon>save</mat-icon>
                      Tallenna tilaus
                    </button>
                  </div>
                </mat-step>
              </mat-stepper>
            </form>
          </mat-card-content>
        </mat-card>

        <!-- Loading State using shared loading pattern -->
        @if (isLoading) {
          <mat-card class="data-card">
            <mat-card-content>
              <div class="table-loading">
                <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
                <p class="text-faint">Ladataan tilauksia...</p>
                <p class="text-faint">Odota hetki, haetaan tietoja järjestelmästä</p>
              </div>
            </mat-card-content>
          </mat-card>
        }

        <!-- Empty State using shared empty pattern -->
        @if (isEmpty && !isLoading) {
          <mat-card class="data-card">
            <mat-card-content>
              <div class="table-empty">
                <mat-icon>inbox</mat-icon>
                <div class="empty-message">Ei tilauksia</div>
                <div class="empty-description">Ei avoimia tilauksia hakuehdoillasi</div>
                <div class="responsive-actions-btns">
                  <button mat-raised-button color="primary" (click)="addNewOrder()">
                    <mat-icon>add</mat-icon>
                    Luo uusi tilaus
                  </button>
                  <button mat-button (click)="resetFilters()">
                    Tyhjennä suodattimet
                  </button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        }

        <!-- Analytics Dashboard Components (NEW - October 2025) -->
        <mat-card class="data-card">
          <mat-card-header class="custom-card-header">
            <mat-card-title class="card-title">
              <mat-icon class="title-icon">analytics</mat-icon>
              Analytics Dashboard - New Components
            </mat-card-title>
            <mat-card-subtitle class="text-faint">
              Demonstrating new analytics and dashboard patterns added October 2025
            </mat-card-subtitle>
          </mat-card-header>

          <mat-card-content>
            <!-- User Profile Header -->
            <div class="user-header">
              <mat-icon class="user-avatar">account_circle</mat-icon>
              <div class="user-details">
                <h2 class="user-name">Matti Meikäläinen</h2>
                <p class="user-title">Project Manager - RaksaInfo Oy</p>
              </div>
            </div>

            <!-- User Metadata Grid -->
            <div class="metadata-grid">
              <div class="metadata-item">
                <mat-icon>badge</mat-icon>
                <div class="metadata-content">
                  <span class="metadata-label">Henkilönumero</span>
                  <span class="metadata-value">EMP-12345</span>
                </div>
              </div>

              <div class="metadata-item">
                <mat-icon>work</mat-icon>
                <div class="metadata-content">
                  <span class="metadata-label">Vastuualue</span>
                  <span class="metadata-value">Helsingin projekti</span>
                </div>
              </div>

              <div class="metadata-item">
                <mat-icon>schedule</mat-icon>
                <div class="metadata-content">
                  <span class="metadata-label">Kokemus</span>
                  <span class="metadata-value">5 vuotta 3 kk</span>
                </div>
              </div>

              <div class="metadata-item">
                <mat-icon>business</mat-icon>
                <div class="metadata-content">
                  <span class="metadata-label">Yritys</span>
                  <span class="metadata-value">RaksaInfo Oy</span>
                </div>
              </div>

              <div class="metadata-item">
                <mat-icon>person</mat-icon>
                <div class="metadata-content">
                  <span class="metadata-label">Esimies</span>
                  <span class="metadata-value">Jaana Virtanen</span>
                </div>
              </div>

              <div class="metadata-item">
                <mat-icon>location_city</mat-icon>
                <div class="metadata-content">
                  <span class="metadata-label">Paikkakunta</span>
                  <span class="metadata-value">Helsinki</span>
                </div>
              </div>
            </div>

            <mat-divider style="margin: 2rem 0;"></mat-divider>

            <!-- Statistics Cards Grid -->
            <h3 class="card-title">
              <mat-icon class="title-icon">assessment</mat-icon>
              Statistics Overview
            </h3>
            <div class="stats-grid">
              <div class="stat-card">
                <mat-icon>schedule</mat-icon>
                <div class="stat-content">
                  <span class="stat-label">Työtunnit yhteensä</span>
                  <span class="stat-value">160.5</span>
                </div>
              </div>

              <div class="stat-card highlight">
                <mat-icon>euro</mat-icon>
                <div class="stat-content">
                  <span class="stat-label">Palkka yhteensä</span>
                  <span class="stat-value">3,245 €</span>
                </div>
              </div>

              <div class="stat-card">
                <mat-icon>work</mat-icon>
                <div class="stat-content">
                  <span class="stat-label">Työkohteita</span>
                  <span class="stat-value">12</span>
                </div>
              </div>

              <div class="stat-card">
                <mat-icon>trending_up</mat-icon>
                <div class="stat-content">
                  <span class="stat-label">Keskituntipalkka</span>
                  <span class="stat-value">20.22 €</span>
                </div>
              </div>
            </div>

            <mat-divider style="margin: 2rem 0;"></mat-divider>

            <!-- Insights Grid -->
            <h3 class="card-title">
              <mat-icon class="title-icon">lightbulb</mat-icon>
              Key Insights
            </h3>
            <div class="insights-grid">
              <div class="insight-item">
                <mat-icon>trending_up</mat-icon>
                <div class="insight-content">
                  <span class="insight-label">Tuntitrendi</span>
                  <span class="insight-value">+15% viime kuukaudesta</span>
                </div>
              </div>

              <div class="insight-item accent">
                <mat-icon>check_circle</mat-icon>
                <div class="insight-content">
                  <span class="insight-label">Suoritettu tehtäviä</span>
                  <span class="insight-value">24 tehtävää valmis</span>
                </div>
              </div>

              <div class="insight-item warn">
                <mat-icon>warning</mat-icon>
                <div class="insight-content">
                  <span class="insight-label">Ylityötunnit</span>
                  <span class="insight-value">12.5 tuntia tällä viikolla</span>
                </div>
              </div>

              <div class="insight-item">
                <mat-icon>schedule</mat-icon>
                <div class="insight-content">
                  <span class="insight-label">Keskimääräinen työpäivä</span>
                  <span class="insight-value">8.2 tuntia</span>
                </div>
              </div>

              <div class="insight-item accent">
                <mat-icon>star</mat-icon>
                <div class="insight-content">
                  <span class="insight-label">Tehokkuus</span>
                  <span class="insight-value">Parempi kuin 75% kollegoista</span>
                </div>
              </div>

              <div class="insight-item">
                <mat-icon>calendar_month</mat-icon>
                <div class="insight-content">
                  <span class="insight-label">Lomat</span>
                  <span class="insight-value">5 päivää jäljellä</span>
                </div>
              </div>
            </div>

            <mat-divider style="margin: 2rem 0;"></mat-divider>

            <!-- Chart Container Examples -->
            <h3 class="card-title">
              <mat-icon class="title-icon">bar_chart</mat-icon>
              Chart Integration
            </h3>

            <div class="app-row">
              <div class="app-col app-col-12 app-col-md-6">
                <div class="chart-container">
                  <div style="display: flex; align-items: center; justify-content: center; height: 100%; background-color: rgba(0,0,0,0.05); border-radius: 8px;">
                    <div style="text-align: center; padding: 2rem;">
                      <mat-icon style="font-size: 64px; width: 64px; height: 64px; line-height: 1; opacity: 0.3;">bar_chart</mat-icon>
                      <p style="margin-top: 1rem; opacity: 0.6;">Default chart container (400px)</p>
                      <p style="font-size: 12px; opacity: 0.5;">NgxCharts component would go here</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="app-col app-col-12 app-col-md-6">
                <div class="chart-container small">
                  <div style="display: flex; align-items: center; justify-content: center; height: 100%; background-color: rgba(0,0,0,0.05); border-radius: 8px;">
                    <div style="text-align: center; padding: 1rem;">
                      <mat-icon style="font-size: 48px; width: 48px; height: 48px; line-height: 1; opacity: 0.3;">pie_chart</mat-icon>
                      <p style="margin-top: 0.5rem; opacity: 0.6; font-size: 14px;">Small chart (300px)</p>
                      <p style="font-size: 11px; opacity: 0.5;">For compact dashboards</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="chart-container tall" style="margin-top: 1rem;">
              <div style="display: flex; align-items: center; justify-content: center; height: 100%; background-color: rgba(0,0,0,0.05); border-radius: 8px;">
                <div style="text-align: center; padding: 2rem;">
                  <mat-icon style="font-size: 72px; width: 72px; height: 72px; line-height: 1; opacity: 0.3;">show_chart</mat-icon>
                  <p style="margin-top: 1rem; opacity: 0.6;">Tall chart container (450px)</p>
                  <p style="font-size: 12px; opacity: 0.5;">For detailed trend visualizations</p>
                </div>
              </div>
            </div>

            <mat-divider style="margin: 2rem 0;"></mat-divider>

            <!-- Empty State Examples -->
            <h3 class="card-title">
              <mat-icon class="title-icon">info</mat-icon>
              Empty States
            </h3>

            <div class="app-row">
              <div class="app-col app-col-12 app-col-md-6">
                <div class="no-data">
                  <mat-icon>inbox</mat-icon>
                  <p>Ei dataa saatavilla</p>
                </div>
              </div>

              <div class="app-col app-col-12 app-col-md-6">
                <div class="no-data compact">
                  <mat-icon>search_off</mat-icon>
                  <p>Hakutuloksia ei löytynyt</p>
                </div>
              </div>
            </div>

            <div style="margin-top: 1rem; padding: 1rem; background-color: rgba(0,0,0,0.03); border-radius: 8px;">
              <p class="text-faint" style="margin: 0; font-size: 13px;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; line-height: 1; vertical-align: middle;">info</mat-icon>
                <strong>New in October 2025:</strong> All analytics components are fully responsive, theme-aware,
                and follow Material Design 3 principles. They work seamlessly with NgxCharts, TranslateService,
                and all existing RaksaInfo modules.
              </p>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Mobile-specific content using shared responsive classes -->
        <div class="show-on-mobile">
          <mat-card class="responsive-spacing">
            <mat-card-content>
              <p class="text-center text-faint">Tämä sisältö näkyy vain mobiililaitteilla</p>
              <p class="text-center text-faint">Optimoitu kenttätyöntekijöille</p>
            </mat-card-content>
          </mat-card>
        </div>

      </div>
